import React from "react";
import PropTypes from "prop-types";
import { Field, ErrorMessage } from "formik";
import InputError from "../styledElements/inputError";
import FormLabel from "../styledElements/label";
import StyledTextarea from "../styledElements/styledTextarea";

const FormikTextarea = ({
    type,
    name,
    label,
    disabled,
    labelWidth,
    labelAlign,
    ...rest
}) => {
    return (
        <React.Fragment>
            <Field name={name}>
                {({ field: { name, onChange }, form: { touched, errors } }) => {
                    const error = !!touched[name] && errors[name];
                    return (
                        <React.Fragment>
                            {label && (
                                <FormLabel
                                    align={labelAlign}
                                    width={labelWidth}
                                    name={name}
                                    {...rest}
                                >
                                    {label}
                                </FormLabel>
                            )}
                            <StyledTextarea
                                {...rest}
                                type={type}
                                name={name}
                                id={name}
                                onChange={onChange}
                                error={error}
                                disabled={disabled}
                            />
                        </React.Fragment>
                    );
                }}
            </Field>
            <ErrorMessage name={name}>
                {msg => <InputError error={msg} />}
            </ErrorMessage>
        </React.Fragment>
    );
};

FormikTextarea.displayName = "FormikTextarea";

FormikTextarea.propTypes = {
    name: PropTypes.string.isRequired,
    type: PropTypes.string,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    disabled: PropTypes.bool,
    height: PropTypes.number,
    rows: PropTypes.number,
    columns: PropTypes.number,
    labelWidth: PropTypes.number,
    labelAlign: PropTypes.string
};

FormikTextarea.defaultProps = {
    size: "default",
    type: "text",
    disabled: false,
    rows: 6,
    columns: 20
};

export default FormikTextarea;
